export const DISMISS_TEXT = {
    PERIOD: {
        ONE_WEEK: '1 Week',
        ONE_MONTH: '1 Month',
    },
    ACTIONS: {
        DISMISS: 'Dismiss',
    },
    TOAST: {
        SUCCESS: 'Card successfully dismissed.',
        ERROR: 'Something was wrong while dismissing this card,please try again later.',
    },
    TEST_ID: {
        DISMISS_OPTIONS: 'dismiss-options-test',
        ONE_WEEK: 'one-week-test',
        ONE_MONTH: 'one-month-test',
    },
    DISMISS_MODAL: {
        TITLE: 'Are you sure ?',
        SUBTITLE: 'Do you really want to dismiss this task for {}? This process cannot be undone.',
        ONE_WEEK: '1 week',
        ONE_MONTH: '1 month',
    },
};

export const ICON_STYLES = {
    SIZE: 18,
    BACKGROUND_COLOR: 'transparent',
};

export const DAYS_TO_DISMISS = {
    ONE_WEEK: 7,
    ONE_MONTH: 30,
};

export const TEST_ID = {
    DISMISS_BUTTON_WRAPPER: 'dismiss-button-wrapper-test',
    DISMISS_OPTIONS: 'dismiss-options-test',
    ONE_WEEK: 'one-week-test',
    ONE_MONTH: 'one-month-test',
};

export const AUTO_TEST_ID = {
    DISMISS_BUTTON_WRAPPER: 'dismiss-button-wrapper-auto-test',
    DISMISS_OPTIONS: 'dismiss-options-auto-test',
    ONE_WEEK: 'one-week-auto-test',
    ONE_MONTH: 'one-month-auto-test',
};
